/**
 * Текст ошибки «сессия истекла» (ответ 401). Один на весь ПИМ: по нему карточки графиков и уведомления об ошибке
 * понимают, что рядом нужна кнопка «Войти» (`SessionExpiredAction`). Отдельный модуль без React — его читают и
 * чистые функции форматирования ошибок.
 */
export const SESSION_EXPIRED_MESSAGE = 'Сессия истекла — войдите снова'

export function isSessionExpiredMessage(message: string | null | undefined): boolean {
  return message === SESSION_EXPIRED_MESSAGE
}
